import { isBoolean, isNumber, isObject, isString } from "@ciaopeople/cp-shatsu/TypeChecking";
import { hasOwnProperty } from "@ciaopeople/cp-shatsu/Utils";
import { isMediaInfoRawData, MediaId, MediaInfoRawData } from "../MediaInfo.js";
import { MediaMetaData } from "../MediaMetaData.js";
import { ThumbnailResource } from "../MediaThumbnailResource.js";
import { VideoFormatRawData } from "./VideoFormat.js";




export interface VideoStoryBoard {
    gap: number,
    url: string 
}

export function isVideoStoryBoard(a: any): a is VideoStoryBoard {
    return isObject(a) && 
            ("gap" in a && isNumber(a.gap)) &&
            ("url" in a && isString(a.url)) 

}

/**
 * informazioni grezze (provenienti da server) con le informazioni sul video
 */
export interface VideoInfoRawData extends MediaInfoRawData<VideoFormatRawData>{

    id: MediaId,
    title: string,
    description?: string,
    url: string,
    linkedResource?: string,
    thumbnail?: ThumbnailResource
    format: VideoFormatRawData[],
    videoOnTop?: boolean,
    socialInfo: {
        share?: number,
        heart?: number,
        view?: number
    }
    meta?: MediaMetaData,
    storyboard?: VideoStoryBoard
};

/**
 * barrier per oggetti di tipo VideoInfoRawData
 * @param obj l'oggetto da verificare
 * @returns 
 */
export function isVideoInfoRawData(obj: any): obj is VideoInfoRawData {
    return isMediaInfoRawData(obj) &&
        (!hasOwnProperty(obj, 'videoOnTop') || isBoolean(obj['videoOnTop'])) &&
        (!hasOwnProperty(obj, 'storyboard') || isVideoStoryBoard(obj['storyboard']));
};